import Image from 'next/image';
import cn from 'classnames';
import i18n from '@/settings/i18n';
import { getStars } from './helpers';

const t = i18n.init('collections');

const TrustpilotStar = (imgProps: { imageSrc: StaticImageData }) => (
  <div className="relative h-4 w-4 xl:h-5 xl:w-5">
    <Image
      src={imgProps.imageSrc}
      alt="trustpilot stars"
      className="h-full w-full object-contain"
    />
  </div>
);

const TrustpilotLogo = (props: { className: string; isWhite?: boolean }) => (
  <svg viewBox="0 0 12 12" className={props.className}>
    <path
      d="M0 5.26328H4.5L6 0.863281L7.5 5.26328H12L6.75 8.92995L9 8.19661L9.75 11.8633L6 9.66328L2.25 11.8633L3.75 7.46328L0 5.26328Z"
      fill={props.isWhite ? '#FFFFFF' : '#1F2323'}
    />
  </svg>
);

const TrustPilot = ({
  isHealthBeautyCollection = false,
}: {
  isHealthBeautyCollection?: boolean;
}) => {
  const stars = getStars({ isHealthBeautyCollection });

  return (
    <div className="flex items-center text-xxs xxs:text-xs md:text-sm xl:text-base">
      <span className="hidden font-normal lg:inline-block">
        {t`Excellent on`}
      </span>
      <span className="inline-block justify-between font-bold lg:hidden">
        4.7{' '}
      </span>
      <div className="mx-1 mb-[3px] xl:mx-2">
        <TrustpilotLogo
          className={cn(
            'h-[13px] w-[13px] md:h-[15px] md:w-[15px] lg:h-4 lg:w-4 xl:h-5 xl:w-5',
          )}
          isWhite={!isHealthBeautyCollection}
        />
      </div>
      <span className="mr-1 inline-block font-bold lg:hidden">{t`on`}</span>
      <b>Trustpilot</b>
      <div className="ml-2 hidden items-center justify-start lg:flex">
        {[...Array(4)].map((_, index) => (
          <TrustpilotStar key={index} imageSrc={stars.fullStar} />
        ))}
        <TrustpilotStar imageSrc={stars.halfStar} />
      </div>
    </div>
  );
};

export default TrustPilot;
